var React = require('react');

function WindowFrameOpen (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M96,224H240V64H96ZM272,64V224H416V64Z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M480,32A32,32,0,0,0,448,0H64A32,32,0,0,0,32,32V288H480ZM240,224H96V64H240Zm176,0H272V64H416Zm80,224H480V320H416V448H96V320H32V448H16A16,16,0,0,0,0,464v32a16,16,0,0,0,16,16H496a16,16,0,0,0,16-16V464A16,16,0,0,0,496,448Z","className":"fa-primary","key":2})]);
}

WindowFrameOpen.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = WindowFrameOpen;

WindowFrameOpen.default = WindowFrameOpen;
